import React, {useState, useEffect} from "react";
import {NavBar, List} from "antd-mobile";
import {CheckCircleFill} from "antd-mobile-icons";
import {useNavigate} from "react-router-dom";
import {t} from "../../i18n";
import {useTranslation} from "react-i18next";

interface PdaLanguagePageProps {
}

const PdaLanguagePage: React.FC<PdaLanguagePageProps> = () => {
    const navigate = useNavigate();
    const {i18n} = useTranslation();
    const [currentLang, setCurrentLang] = useState('zh-CN');

    useEffect(() => {
        setCurrentLang(i18n.language);
    }, [i18n.language]);

    const handleLanguageChange = (lang: string) => {
        setCurrentLang(lang);
        i18n.changeLanguage(lang)
            .then(() => {
                window.location.reload();
            })
            .catch((err: Error) => {
            });
    };

    return (
        <div className="flex flex-col h-screen bg-white">
            <NavBar
                onBack={() => navigate(-1)}
            >
                {t('pages.useMenu.language')}
            </NavBar>

            <List className="mt-2">
                <List.Item
                    extra={currentLang === 'zh-CN' || currentLang === 'zh' ? <CheckCircleFill color="#00b578"/> : null}
                    onClick={() => handleLanguageChange('zh')}
                    arrowIcon={false}
                >
                    简体中文
                </List.Item>
                <List.Item
                    extra={currentLang === 'en-US' || currentLang === 'en' ? <CheckCircleFill color="#00b578"/> : null}
                    onClick={() => handleLanguageChange('en')}
                    arrowIcon={false}
                >
                    English
                </List.Item>
                <List.Item
                    extra={currentLang === 'es-ES' || currentLang === 'es' ? <CheckCircleFill color="#00b578"/> : null}
                    onClick={() => handleLanguageChange('es')}
                    arrowIcon={false}
                >
                    Español
                </List.Item>
            </List>
        </div>
    );
};

export default PdaLanguagePage; 